const _state = {
  loading: false,
    totalRequest: 0,
    isNavOpen: false,
    isMobileDensity: false,
  }
  
  export const initialState = () => _state
  
  export const state = initialState()
  